export default class GetOrderersModel {
  constructor({ code, name } = {}) {
    this.code = code || null;
    this.name = name || null;
  }
}
